import React, {useEffect} from "react";
import { v4 as uuidv4 } from 'uuid';
import { getSessionCookie } from "services/session.js";

const InputImage = (props) => {
    const session = getSessionCookie();
    const inputImage = React.useRef(null);
    const [image, setImage] = React.useState(props.image == null ? require("assets/img/theme/camera.png") : (props.image.base64 == null ? session.pathVirtual + props.image.name : "data:image/png;base64," + props.image.base64))
    const handleImage = (event) => {        
        if (event.target.files.length) {                
            setImage(URL.createObjectURL(event.target.files[0]));                 
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]); 
            reader.onloadend = function() {
                var base64data = reader.result;                                    
                props.uploadImage(
                    {base64: base64data.replace("data:image/png;base64,", "").replace("data:image/jpg;base64,", "").replace("data:image/jpeg;base64,", ""), 
                    name: uuidv4() + ".png"
                }, props.image == null ? "" : props.image.name);
            }                
        }
    }
    const handleClickImage = () => {
        inputImage.current.click();
    }

    useEffect(() => {           
        if (props.image != null)
        {
            if (props.image.base64 != null)
                setImage("data:image/png;base64," + props.image.base64);
            else
                setImage(session.pathVirtual + props.image.name);
        }
    }, [props.image]);

        return (
            <>        
            <input 
                {...props}
                type="file"        
                accept=".png,.jpg,.jpeg"                 
                ref={inputImage}
                className={"d-none"}
                onChange={handleImage}
            />
            <img style={{height:"7rem", maxWidth:"7rem", cursor:"pointer"}} src={image} onClick={handleClickImage}/>    
            <br/>
            {(image != require("assets/img/theme/camera.png") && props.image != null && props.image.base64 == null) && 
            <a target="_blank" href={image}>Abrir Imagem</a>}
            </>
        )
    }

export default InputImage;